// Tiny, dependency-free humanizer for the handful of cron shapes the /agents
// UI offers as presets (plus common freeform ones). Anything it can't confidently
// read falls back to the raw expression — the card shows that raw string as a
// tooltip regardless, so an unrecognized cron is never lost.

const WEEKDAY_NAMES = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

export function humanizeCron(cron: string | null | undefined): string {
  if (!cron || !cron.trim()) return 'Manual only';

  const parts = cron.trim().split(/\s+/);
  if (parts.length !== 5) return cron;

  const [min, hour, dom, mon, dow] = parts;
  const isNum = (v: string) => /^\d+$/.test(v);
  const pad = (v: string) => v.padStart(2, '0');
  const time = isNum(min) && isNum(hour) ? `${pad(hour)}:${pad(min)}` : null;

  // every N minutes
  const everyMin = min.match(/^\*\/(\d+)$/);
  if (everyMin && hour === '*' && dom === '*' && mon === '*' && dow === '*') {
    return `every ${everyMin[1]} min`;
  }

  // hourly (optionally at a fixed minute)
  if (isNum(min) && hour === '*' && dom === '*' && mon === '*' && dow === '*') {
    return min === '0' ? 'hourly' : `hourly at :${pad(min)}`;
  }

  if (time && dom === '*' && mon === '*') {
    if (dow === '*') return `daily ${time}`;
    if (dow === '1-5') return `weekdays ${time}`;
    if (dow === '0,6' || dow === '6,0') return `weekends ${time}`;
    if (/^\d$/.test(dow)) return `${WEEKDAY_NAMES[Number(dow)] ?? dow} ${time}`;
    return `${time} (${dow})`;
  }

  return cron;
}
